<template lang="pug">
  .cancel-sub-btn.text-center
    button.mr-btn.btn-tertiary(@click="editAutoDeliveryCancelFinalModal") Cancel Subscription
  
</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    name: "CancelSubBtn",
    methods: {
      ...mapActions('subscriptions', [
        'editAutoDeliveryCancelFinalModal'
      ])
    }
   }
</script>

<style scoped lang="stylus">

</style>